import type { Step } from "../types";

const STEPS: Step[] = ["service", "slot", "details", "payment", "confirmed"];

export default function StepIndicator({ step }: { step: Step }) {
  const currentIndex = STEPS.indexOf(step);
  return (
    <div className="flex gap-2">
      {STEPS.map((s, i) => (
        <div
          key={s}
          className={`h-1 flex-1 rounded-full ${
            i <= currentIndex ? "bg-accent" : "bg-foreground/10"
          }`}
        />
      ))}
    </div>
  );
}
